<template>
  <div
:id="id"
class="mx-2 mb-2 data-table-footer"
>
    <b-row>
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <span class="text-muted">Showing {{ from }} to {{ to }} of {{ of }} entries</span>
      </b-col>
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-pagination
          :id="`${id}-pagination`"
          :value="currentPage"
          :total-rows="total"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
          @input="$emit('update:current-page', $event)"
        >
          <template #prev-text>
            <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
          </template>
          <template #next-text>
            <feather-icon
icon="ChevronRightIcon"
size="18"
/>
          </template>
        </b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BPagination } from 'bootstrap-vue'

export default {
  name: 'DataTableFooter',
  components: { BRow, BCol, BPagination },
  props: {
    id: {
      type: String,
      required: true,
    },
    from: {
      type: Number,
      default: 0,
    },
    to: {
      type: Number,
      default: 0,
    },
    of: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
}
</script>